export default {
  plural: 'Transactions',
  noPlural: 'No transactions',
  deleteImport: 'Delete transaction import',
  balanceTypes: {
    debitAccount: 'Debit account',
    creditAccount: 'Credit account',
    projectAccount: 'Projects',
    taskAccount: 'Tasks',
    amount: 'Old account',
    prepaidAmount: 'Prepaid account',
    bonusAmount: 'Bonus amount'
  },
  totalBalance: 'Total balance'
};
